import React, { Component, createRef } from "react";
import PropTypes from "prop-types";
import Icon from "./Icon";
import Button from "./Button";
import styles from "./EditableLabel.module.css";

const ENTER_KEY = 13;

export default class EditableLabel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editing: false,
    };
    this.editRef = createRef();
  }

  componentWillMount() {
    this.onEdit = this.onEdit.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
  }

  componentDidUpdate() {
    if (this.editRef?.current) {
      this.editRef.current.select();
    }
  }

  onEdit() {
    this.setState({
      editing: true,
    });
  }

  onKeyDown(e) {
    if (e.keyCode === ENTER_KEY) {
      this.setState({
        editing: false,
      });

      this.props.onChange(this.editRef?.current.value);
    }
  }

  render() {
    const labelStyle = {
      maxWidth: parseInt(this.props.width) - 50,
    };

    const icon = this.props.icon ? (
      <span className={styles.icon}>
        <Icon icon={this.props.icon} />
      </span>
    ) : undefined;

    return this.state.editing ? (
      <span className={styles.container}>
        {icon}
        <input
          ref={this.editRef}
          defaultValue={this.props.value}
          onKeyDown={this.onKeyDown}
        />
      </span>
    ) : (
      <span className={styles.container}>
        {icon}
        <span className={styles.name} style={labelStyle}>
          {this.props.value}
        </span>{" "}
        <Button className={styles.button} type="link" onClick={this.onEdit}>
          <Icon icon="pencil" style={{ transform: "none" }} />
        </Button>
      </span>
    );
  }
}
